import {
  Badge,
  Table,
} from 'react-bootstrap';
import './MercurXStakeTable.scss';
import { connect } from 'react-redux';
import MercurXIcons from '../MercurXIcons/MercurXIcons';
import { mainColors } from '../../helpers/colors';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import useMercurxPagination from '../../hooks/useMercurxPagination';
import MercurXTablePagination from '../MercurXTablePagination/MercurXTablePagination';
import MercurXSortableHeader from '../MercurXSortableHeader/MercurXSortableHeader';
import { getStakeRowKey } from '../../helpers/stakeRowKey';
import {
  setStakesSortDataAction,
  sortStakesAction,
} from '../../store/stake/stakeActions';
import {
  STAKES_SORT_KEYS,
  STAKES_SORT_TYPES,
} from '../../pages/Stakes/stakesConstants';

function MercurXStakeTable(props) {
  const {
    stakes,
    filteredStakes,
    stakesSortData,
    setStakesSortData,
    sortStakes,
  } = props;
  const sourceData = filteredStakes || stakes || [];
  const {
    currentPage,
    totalPages,
    visiblePages,
    pagedData: renderedStakes,
    rowOffset,
    isFirstPage,
    isLastPage,
    goToPage,
    goToFirstPage,
    goToPrevPage,
    goToNextPage,
    goToLastPage,
  } = useMercurxPagination(sourceData, 10, 5, {
    resetPageOnDataChange: false,
  });

  function scrollToStakesContainer() {
    const stakesContainer = document.getElementById('stakes-container');
    if (stakesContainer) {
      stakesContainer.scrollIntoView({ behavior: 'smooth' });
    }
  }

  const handlePageChange = (page) => {
    goToPage(page);
    scrollToStakesContainer();
  };

  const handleFirstPage = () => {
    goToFirstPage();
    scrollToStakesContainer();
  };

  const handlePrevPage = () => {
    goToPrevPage();
    scrollToStakesContainer();
  };

  const handleNextPage = () => {
    goToNextPage();
    scrollToStakesContainer();
  };

  const handleLastPage = () => {
    goToLastPage();
    scrollToStakesContainer();
  };

  const formatDateClaim = (originalDate) => {
    const dateObj = new Date(originalDate);

    return new Date(
      dateObj.getUTCFullYear(),
      dateObj.getUTCMonth(),
      dateObj.getUTCDate(),
      dateObj.getUTCHours() + 3,
      dateObj.getUTCMinutes(),
      dateObj.getUTCSeconds(),
    );
  };

  function formatDateStartEnd(dateString) {
    const originalDate = new Date(dateString);
    const adjustedDate = new Date(originalDate.getTime() - 3 * 60 * 60 * 1000);
    const options = {
      year: 'numeric', month: 'numeric', day: 'numeric',
      hour: 'numeric', minute: 'numeric', second: 'numeric',
    };
    const formattedDate = new Intl.DateTimeFormat('default', options).format(adjustedDate);

    return formattedDate;
  }

  const handleSort = (sortKey, defaultSortType) => {
    const nextSortType = stakesSortData.sortKey === sortKey
      ? (stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING
        ? STAKES_SORT_TYPES.DESCENDING
        : STAKES_SORT_TYPES.ASCENDING)
      : defaultSortType;

    setStakesSortData({
      sortKey,
      sortType: nextSortType,
    });
    sortStakes();
  };

  return (
    <>
      <Table className="stakes-table-design" responsive hover borderless>
        <thead>
          <tr className="text-t-body-color text-fs-tag">
            <th>#</th>
            <th>
              <MercurXSortableHeader
                label="Token Symbol"
                isActive={stakesSortData.sortKey === STAKES_SORT_KEYS.TOKEN_NAME}
                isAscending={stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  STAKES_SORT_KEYS.TOKEN_NAME,
                  STAKES_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Value"
                isActive={stakesSortData.sortKey === STAKES_SORT_KEYS.VALUE}
                isAscending={stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  STAKES_SORT_KEYS.VALUE,
                  STAKES_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Wallet Address"
                isActive={stakesSortData.sortKey === STAKES_SORT_KEYS.WALLET}
                isAscending={stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  STAKES_SORT_KEYS.WALLET,
                  STAKES_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Txn Hash"
                isActive={stakesSortData.sortKey === STAKES_SORT_KEYS.TRANSACTION_HASH}
                isAscending={stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  STAKES_SORT_KEYS.TRANSACTION_HASH,
                  STAKES_SORT_TYPES.ASCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Start Time"
                isActive={stakesSortData.sortKey === STAKES_SORT_KEYS.START_DATE}
                isAscending={stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  STAKES_SORT_KEYS.START_DATE,
                  STAKES_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="End time"
                isActive={stakesSortData.sortKey === STAKES_SORT_KEYS.END_DATE}
                isAscending={stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  STAKES_SORT_KEYS.END_DATE,
                  STAKES_SORT_TYPES.DESCENDING
                )}
              />
            </th>
            <th>
              <MercurXSortableHeader
                label="Status"
                isActive={stakesSortData.sortKey === STAKES_SORT_KEYS.STATUS}
                isAscending={stakesSortData.sortType === STAKES_SORT_TYPES.ASCENDING}
                onClick={() => handleSort(
                  STAKES_SORT_KEYS.STATUS,
                  STAKES_SORT_TYPES.DESCENDING
                )}
              />
            </th>
          </tr>
        </thead>
        {renderedStakes?.length ? (
          <tbody>
            {renderedStakes.map((item, index) => (
              <tr
                className="text-t-head-color"
                key={getStakeRowKey(item, rowOffset + index)}
              >
                <td>{rowOffset + index + 1}</td>
                <td>{item.symbol}</td>
                <td>{item.value}</td>
                <td>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`wallet-tooltip-${index}`}>{item.wallet}</Tooltip>}
                  >
                    <div>{`${item.wallet.slice(0, 3)}...${item.wallet.slice(-3)}`}</div>
                  </OverlayTrigger>
                </td>
                <td>
                  <OverlayTrigger
                    placement="top"
                    overlay={<Tooltip id={`hash-tooltip-${index}`}>{item.tx_hash}</Tooltip>}
                  >
                    <div>{`${item.tx_hash.slice(0, 3)}...${item.tx_hash.slice(-3)}`}</div>
                  </OverlayTrigger>
                </td>
                <td>{formatDateStartEnd(item.start_lock_time) + ' GMT+3'}</td>
                <td>
                  {!item.claim_status
                    ? formatDateClaim(item.udate).toLocaleString() + ' GMT+3'
                    : ''}
                </td>
                <td>
                  {item.claim_status ? (
                    <Badge bg="primary">Staked</Badge>
                  ) : (
                    <Badge bg="primary">Done</Badge>
                  )}
                </td>
                <td>
                  <p className="border-bottom-detail mt-1">
                    <a
                      href={'https://testnet.bscscan.com/tx/' + item.tx_hash}
                      target="_blank"
                      rel="noreferrer"
                      className="link"
                    >
                      <MercurXIcons
                        name="BsFillInfoSquareFill"
                        size={18}
                        color={mainColors.primary}
                      />
                    </a>
                  </p>
                </td>
              </tr>
            ))}
          </tbody>
        ) : null}
      </Table>
      {!renderedStakes?.length && (
        <div className="d-flex text-fs-body-md text-t-body-color justify-content-center">
          No stake found according to search results.
        </div>
      )}
      <MercurXTablePagination
        currentPage={currentPage}
        totalPages={totalPages}
        visiblePages={visiblePages}
        isFirstPage={isFirstPage}
        isLastPage={isLastPage}
        onFirstPage={handleFirstPage}
        onPrevPage={handlePrevPage}
        onPageChange={handlePageChange}
        onNextPage={handleNextPage}
        onLastPage={handleLastPage}
      />
    </>
  );
}

const mapStateToProps = (state) => {
  return {
    stakes: state.stakeReducer.stakes,
    filteredStakes: state.stakeReducer.filteredStakes,
    stakesSortData: state.stakeReducer.stakesSortData,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    setStakesSortData: (payload) => {
      dispatch(setStakesSortDataAction(payload));
    },
    sortStakes: () => {
      dispatch(sortStakesAction());
    },
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(MercurXStakeTable);
